import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@mui/material/Paper';
import { styled } from '@mui/system';

import { getMenuItemNamesLighterColor } from 'styles/helpers/getThemeStyles';

const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.card.background.main,
  position: 'sticky',
  bottom: 0,
  borderTop: `1px solid ${getMenuItemNamesLighterColor(theme)}`,
  borderRadius: '0px 0px 8px 8px',
  width: '100%',
  padding: '0px 20px 20px'
}));

function StickyPaper({ children }) {
  return (
    <StyledPaper data-testid="sticky-paper" elevation={0}>
      {children}
    </StyledPaper>
  );
}

StickyPaper.propTypes = {
  children: PropTypes.array
};

export default StickyPaper;
